export enum SellarCreditTwoDialogPageEnum {
  WELCOME,
  SEARCH_COMPANY,
  TWO_BUSINESS_REGISTRATION_APPLICATION,
  NOT_ELIGIBLE,
  CREDIT_LIMIT,
  TWO_ACCOUNT_VERIFICATION_INTRO,
  TWO_ACCOUNT_VERIFICATION_GET_STARTED,
  LOGIN_CHECK,
  LOGIN_PROMPT,
  INVITE_DIRECTOR,
}
